import { NameInput, RedirectInput, SourceInput, MediumInput } from "./LinkInputs";
import { useLinkTaxonomy } from "./useLinkTaxonomy";

export function LinkForm({ control, errors }: { control: any; errors: any }) {
  const { mediums, sources } = useLinkTaxonomy();

  return (
    <form id="link-form" onSubmit={(e) => e.preventDefault()}>
      <div className="grid gap-4">
        <NameInput control={control} errors={errors} />
        <RedirectInput control={control} errors={errors} />
        <SourceInput control={control} errors={errors} options={sources} />
        <MediumInput control={control} errors={errors} options={mediums} />
      </div>
    </form>
  );
}
